import styled, { css } from 'styled-components';
import { Input } from 'antd';

type IErrors = {
    error?: string | string[];
};

export const StyledInput = styled(Input)<IErrors>`
    && {
        ${({ theme, error }) => css`
            font-size: ${theme.fontSizes.default};
            height: 3.5rem;
            border-radius: 8px;
            color: ${theme.colors.font};

            &:hover,
            &:focus {
                ${!error &&
                css`
                    border-color: ${theme.colors.accentColor};
                `};
            }

            ${error &&
            css`
                border-color: ${theme.colors.fail};
            `};
        `};
    }
`;

export const Title = styled.p`
    ${({ theme }) => css`
        color: ${theme.colors.font};
        font-size: ${theme.fontSizes.little};
        margin-bottom: 0.5rem;
    `}
`;

export const Container = styled.div`
    display: flex;
    flex-direction: column;
`;

export const BadgeContainer = styled.div`
    display: flex;
    margin-top: 1rem;
    flex-wrap: wrap;
`;
